export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const randomDelay = (min = 200, max = 800) =>
  sleep(Math.floor(Math.random() * (max - min + 1) + min));
